// extracted by mini-css-extract-plugin
export default {"guidedTour":"styles_guidedTour__pSae8","tourButton":"styles_tourButton__f4WTd"};